import { render, staticRenderFns } from "./hompage.vue?vue&type=template&id=4b798d48&"
import script from "./hompage.vue?vue&type=script&lang=js&"
export * from "./hompage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports